import { Divider, Grid } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Header } from "../../../Components/Header/Header";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";

import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";

export const UserList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const source = {
    url: "users/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "",
        value: ""
      }
    ],
    sort: []
  };

  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/user/${row?._id}`);
    }
    if (action === "Delete") {
      setSelectedId(row._id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const handleClick = () => {
    navigate("/user");
  };

  const handleDelete = () => {
    dispatch(resetDataComponent("userList"));
    showMessage("User deleted successfully!", "success");
  };

  const columns: IColumns[] = [
    {
      header: "User Name",
      fieldName: "name",
      type: "default"
    },
    {
      header: "Phone Number",
      fieldName: "phone",
      type: "default"
    },
    {
      header: "Email",
      fieldName: "email",
      type: "default"
    },

    {
      header: "Role",
      fieldName: "role",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  return (
    <>
      {" "}
      <Grid item container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Header
        type="simple"
        isDivider={true}
        title="Users"
        id={"userListHeader"}
        headerSx={{ marginTop: 0 }}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="userList"
            title="Users"
            columns={columns}
            source={source}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />

          {selectedId !== null && (
            <ConfirmationPopup
              apiUrl={"users/delete"}
              id={selectedId}
              confirmMessage="Are you sure you want to remove this customer?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
              permanent
            />
          )}
        </Grid>
      </Grid>
    </>
  );
});
